// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"375":"workshop-edit-jon","531":"workshop-edit-job","772":"workshop","782":"group-job"}[chunkId] || chunkId) + "-legacy." + {"57":"0d2d274c","107":"451ba98f","375":"9f031682","531":"e3187abe","565":"631378b9","643":"84f7f442","772":"de9ed56f","782":"902c46b4"}[chunkId] + ".js";
};